// Source: https://thomashunter.name/posts/2021-12-11-detecting-if-pwa-twa-is-installed

const UA = navigator.userAgent;

const IOS = UA.match(/iPhone|iPad|iPod/);
const ANDROID = UA.match(/Android/);

export const PLATFORM = IOS ? 'ios' : ANDROID ? 'android' : 'unknown';

const standalone = window.matchMedia('(display-mode: standalone)').matches;

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
//@ts-ignore
const iOSStandalone = IOS && window.navigator.standalone;

export const INSTALLED = !!(standalone || iOSStandalone);

export const IS_IOS_APP = document.cookie
  .split(';')
  .some(cookie => decodeURIComponent(cookie.trim()) === 'app-platform=iOS App Store');
